/**
 * The blocks whose Log was sent, or tried again, from the block popup, until
 * the popup has been told they're logged (ADR 0184). The popup keeps them,
 * not its Log form: the form goes when the popup closes or steps to another
 * block, and a block sent from the popup and opened again while it logs
 * still closes the popup once it's logged (owner report, 2026-10-21, on
 * v0.9.0-rc.1's staging test).
 */
import { createContext, useContext, useState } from "react";

export class SentHere {
  private readonly blockIds = new Set<string>();

  add(blockId: string): void {
    this.blockIds.add(blockId);
  }

  /** Whether it was sent from here and not told yet. Told once: it's let go. */
  take(blockId: string): boolean {
    return this.blockIds.delete(blockId);
  }
}

/** The block popup's (BlockPopup); null outside one. */
export const SentHereContext = createContext<SentHere | null>(null);

/** The popup's; outside one (a form on its own in a test), the form's own. */
export function useSentHere(): SentHere {
  const popup = useContext(SentHereContext);
  const [own] = useState(() => new SentHere());
  return popup ?? own;
}
